"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var SpacesDataStatus_1 = require("../../gen-src/icons/SpacesDataStatus");
var SpacesDataStatusActive_1 = require("../../gen-src/icons/SpacesDataStatusActive");
var SpacesDataStatusHeaderOutline_1 = require("../../gen-src/icons/SpacesDataStatusHeaderOutline");
var SpacesMediumDs_1 = require("../../gen-src/icons/SpacesMediumDs");
var SpacesMediumExternalServer_1 = require("../../gen-src/icons/SpacesMediumExternalServer");
var SpacesMediumFile_1 = require("../../gen-src/icons/SpacesMediumFile");
var SpacesMediumFlow_1 = require("../../gen-src/icons/SpacesMediumFlow");
var SpacesMediumTable_1 = require("../../gen-src/icons/SpacesMediumTable");
var WarningHighSeverity_1 = require("../../gen-src/icons/WarningHighSeverity");
var WarningHighSeverityActive_1 = require("../../gen-src/icons/WarningHighSeverityActive");
var Localize_1 = require("../../gen-src/Localize");
var UserDisplayComponent_1 = require("../components/UserDisplayComponent");
var FeatureFlagsContext_1 = require("../featureFlags/FeatureFlagsContext");
var DataQualityStyles_1 = require("../style/DataQualityStyles");
var VizPortalStyles_1 = require("../style/VizPortalStyles");
var StringInterpolation_1 = require("../utils/StringInterpolation");
var TypescriptHelpers_1 = require("../utils/TypescriptHelpers");
var ViewerPaneLayoutComponents_1 = require("../vizclient/ViewerPaneLayoutComponents");
var DataQualityType_1 = require("./DataQualityType");
var DataQualityDetailChipId = 'data-quality-detail-chip-id';
var DataQualityDetailMessageId = 'data-quality-detail-message-id';
// SCARY NOTE: if this is an "interactive-inline" the ref comes from React.forwardRef()
// if it's "interactive-icon" the setRef callback is used. When the SharedWidgets team allows forward ref in ButtonWidget, get rid of setRef
exports.DataQualityTooltipButton = React.forwardRef(function (props, ref) {
    var _a;
    var inlineAlertProps = {
        testId: props.testId,
        type: props.isSevere ? widgets_1.InlineAlertType.Warning : widgets_1.InlineAlertType.Info,
        children: (_a = props.text, (_a !== null && _a !== void 0 ? _a : props.text))
    };
    switch (props.kind) {
        case 'interactive-icon':
            return (React.createElement(widgets_1.ButtonWidget, { style: DataQualityStyles_1.DataQualityStatusIconButtonStyle, title: '', ref: props.setRef, testId: props.testId, onClick: props.onClick, buttonType: widgets_1.ButtonType.IconOutline, getContent: function (s) { return React.createElement(DataStatusIcon, { isSevere: props.isSevere, hover: s.hover || false }); } }));
        case 'interactive-inline':
            return (React.createElement(widgets_1.CompactInlineAlertWidget, __assign({}, inlineAlertProps, { ref: ref, onClick: props.onClick })));
        case 'non-interactive-inline':
            return (React.createElement(widgets_1.CompactInlineAlertWidget, __assign({}, inlineAlertProps)));
        default:
            TypescriptHelpers_1.assertUnreachable(props);
            return React.createElement(React.Fragment, null);
    }
});
function DataStatusHeaderIcon(props) {
    return React.createElement(SpacesDataStatusHeaderOutline_1.SvgSpacesDataStatusHeaderOutline, { className: props.className });
}
exports.DataStatusHeaderIcon = DataStatusHeaderIcon;
function DataStatusAnchored(props) {
    if (props.hover) {
        return props.isSevere ?
            React.createElement(WarningHighSeverityActive_1.SvgWarningHighSeverityActive, { className: DataQualityStyles_1.DataQualityStatusChipIconClass }) :
            React.createElement(SpacesDataStatusActive_1.SvgSpacesDataStatusActive, { className: DataQualityStyles_1.DataQualityStatusChipIconClass });
    }
    else {
        return props.isSevere ?
            React.createElement(WarningHighSeverity_1.SvgWarningHighSeverity, { className: DataQualityStyles_1.DataQualityStatusChipIconClass }) :
            React.createElement(SpacesDataStatus_1.SvgSpacesDataStatus, { className: DataQualityStyles_1.DataQualityStatusChipIconClass });
    }
}
function DataStatusIcon(props) {
    return (React.createElement(FeatureFlagsContext_1.FeatureFlagsContext.Consumer, null, function (ff) { return React.createElement(DataStatusAnchored, { hover: props.hover, isSevere: ff.catalogSevereWarningsEnabled ? props.isSevere : false }); }));
}
function DataQualityAuthorLink(props) {
    return React.createElement("a", { href: props.url, target: '_blank', className: VizPortalStyles_1.linkClass, title: props.name }, props.name);
}
function DataQualityAuthorElement(props) {
    var userElement = props.linksDisabled
        ? React.createElement(UserDisplayComponent_1.UserTextDisplayComponent, { user: props.author })
        : React.createElement(UserDisplayComponent_1.UserLinkDisplayComponent, { user: props.author, linkComponent: DataQualityAuthorLink });
    return (React.createElement(React.Fragment, null, StringInterpolation_1.interpolateString(Localize_1.Messages.DataQualityAuthor({ name: '[AUTHOR_NAME_TOKEN]' }), { 'AUTHOR_NAME_TOKEN': React.createElement("span", { key: 'author' }, userElement) })));
}
exports.DataQualityAuthorElement = DataQualityAuthorElement;
// This is adapted from DatabaseMediumIcon, but without certification and with additional
// connection types.
function assetIconForType(typename) {
    switch (typename) {
        case 'CloudFile':
        case 'File':
            return React.createElement(SpacesMediumFile_1.SvgSpacesMediumFile, null);
        case 'DatabaseServer':
        case 'WebDataConnector':
            return React.createElement(SpacesMediumExternalServer_1.SvgSpacesMediumExternalServer, null);
        case 'DatabaseTable':
            return React.createElement(SpacesMediumTable_1.SvgSpacesMediumTable, null);
        case 'Flow':
            return React.createElement(SpacesMediumFlow_1.SvgSpacesMediumFlow, null);
        case 'PublishedDatasource':
            return React.createElement(SpacesMediumDs_1.SvgSpacesMediumDs, null);
        default:
            return null;
    }
}
function dataQualityDetailAsset(props) {
    if (props.name === null) {
        return getPermissionRequiredMessage();
    }
    var assetIcon = assetIconForType(props.assetType);
    if (props.url) {
        return ViewerPaneLayoutComponents_1.SingleLineLinkWithIcon({
            linkText: props.name || null,
            linkHref: props.url,
            iconComponent: assetIcon,
            iconSize: 'small',
        });
    }
    else {
        return ViewerPaneLayoutComponents_1.SingleLineTextWithIcon({
            text: props.name || null,
            iconComponent: assetIcon,
            iconSize: 'small',
        });
    }
}
function getPermissionRequiredMessage() {
    var name = Localize_1.Messages.PermissionRequired();
    return React.createElement("span", { key: 'asset-' + name, style: DataQualityStyles_1.DataQualityDetailPermissionRequired }, name);
}
function getObfuscateMessage(message, name) {
    return name === null ? Localize_1.Messages.PermissionRequiredMessage() : message;
}
function DataQualityDetail(props) {
    var inlineProps = __assign(__assign({}, props), { testId: DataQualityDetailChipId, kind: 'non-interactive-inline', text: DataQualityType_1.localizeDataQualityTypeName(props.type) });
    return (React.createElement(DataQualityStyles_1.DataQualityDetailStyle, null,
        React.createElement(exports.DataQualityTooltipButton, __assign({}, inlineProps)),
        React.createElement(DataQualityStyles_1.DataQualityDetailAssetStyle, null, dataQualityDetailAsset({
            name: props.assetName,
            assetType: props.assetType,
            url: props.linksDisabled ? undefined : props.assetUrl
        })),
        React.createElement(DataQualityStyles_1.DataQualityDetailAuthorStyle, null,
            React.createElement(DataQualityAuthorElement, __assign({}, props))),
        React.createElement(DataQualityStyles_1.DataQualityDetailDateStyle, null, props.localizedDate),
        React.createElement(DataQualityStyles_1.DataQualityDetailMessageStyle, { id: DataQualityDetailMessageId }, getObfuscateMessage(props.message || '', props.assetName))));
}
exports.DataQualityDetail = DataQualityDetail;
//# sourceMappingURL=DataQualityDetail.js.map